module.exports = __webpack_public_path__ + "static/schnitzel.guel-312b4370bbce95f7b3fbf6e4259d31de.jpg";